var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from "class-transformer";
import { IsBoolean, IsDateString, IsNumber, IsOptional, IsString } from "class-validator";
import { safeAssign } from "./safe-assign";
export class GetCostStructureDTO {
    constructor(vals) {
        safeAssign(this, vals);
    }
}
__decorate([
    Expose(),
    IsDateString(),
    __metadata("design:type", String)
], GetCostStructureDTO.prototype, "from", void 0);
__decorate([
    Expose(),
    IsDateString(),
    __metadata("design:type", String)
], GetCostStructureDTO.prototype, "to", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], GetCostStructureDTO.prototype, "includeAncillaryCosts", void 0);
export class GetCostsByVenueDTO {
    constructor(vals) {
        safeAssign(this, vals);
    }
}
__decorate([
    Expose(),
    IsDateString(),
    __metadata("design:type", String)
], GetCostsByVenueDTO.prototype, "from", void 0);
__decorate([
    Expose(),
    IsDateString(),
    __metadata("design:type", String)
], GetCostsByVenueDTO.prototype, "to", void 0);
__decorate([
    Expose(),
    IsNumber({}, { each: true }),
    __metadata("design:type", Array)
], GetCostsByVenueDTO.prototype, "venueIds", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], GetCostsByVenueDTO.prototype, "includeAncillaryCosts", void 0);
export class CostByComponentsDTO {
    constructor(vals) {
        safeAssign(this, vals);
    }
}
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], CostByComponentsDTO.prototype, "base", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], CostByComponentsDTO.prototype, "breaks", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], CostByComponentsDTO.prototype, "bonuses", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], CostByComponentsDTO.prototype, "meals", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], CostByComponentsDTO.prototype, "commission", void 0);
export class CostByStatusDTO {
    constructor(vals) {
        safeAssign(this, vals);
    }
}
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], CostByStatusDTO.prototype, "working", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], CostByStatusDTO.prototype, "sick", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], CostByStatusDTO.prototype, "vacation", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], CostByStatusDTO.prototype, "childSick", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], CostByStatusDTO.prototype, "sickInKug", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], CostByStatusDTO.prototype, "hourAdjustment", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], CostByStatusDTO.prototype, "vacationAdjustment", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], CostByStatusDTO.prototype, "compday", void 0);
export class CostByEmploymentTypeDTO {
    constructor(vals) {
        safeAssign(this, vals);
    }
}
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], CostByEmploymentTypeDTO.prototype, "regular", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], CostByEmploymentTypeDTO.prototype, "marginal", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], CostByEmploymentTypeDTO.prototype, "independent", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], CostByEmploymentTypeDTO.prototype, "shortTerm", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], CostByEmploymentTypeDTO.prototype, "trainee", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], CostByEmploymentTypeDTO.prototype, "midiJob", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], CostByEmploymentTypeDTO.prototype, "workingStudent", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], CostByEmploymentTypeDTO.prototype, "dualStudent", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], CostByEmploymentTypeDTO.prototype, "intern", void 0);
export class CostStructureDTO {
    constructor(vals) {
        safeAssign(this, vals);
    }
}
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], CostStructureDTO.prototype, "total", void 0);
__decorate([
    Expose(),
    Type(() => CostByComponentsDTO),
    __metadata("design:type", CostByComponentsDTO)
], CostStructureDTO.prototype, "components", void 0);
__decorate([
    Expose(),
    Type(() => CostByStatusDTO),
    __metadata("design:type", CostByStatusDTO)
], CostStructureDTO.prototype, "status", void 0);
__decorate([
    Expose(),
    Type(() => CostByEmploymentTypeDTO),
    __metadata("design:type", CostByEmploymentTypeDTO)
], CostStructureDTO.prototype, "employmentType", void 0);
export class DepartmentCostDTO {
    constructor(vals) {
        safeAssign(this, vals);
    }
}
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], DepartmentCostDTO.prototype, "departmentId", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], DepartmentCostDTO.prototype, "name", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], DepartmentCostDTO.prototype, "total", void 0);
export class VenueCostDTO {
    constructor(vals) {
        safeAssign(this, vals);
    }
}
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], VenueCostDTO.prototype, "venueId", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], VenueCostDTO.prototype, "name", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], VenueCostDTO.prototype, "total", void 0);
__decorate([
    Expose(),
    Type(() => DepartmentCostDTO),
    __metadata("design:type", Array)
], VenueCostDTO.prototype, "departments", void 0);
export class CostsByVenueDTO {
    constructor(vals) {
        safeAssign(this, vals);
    }
}
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], CostsByVenueDTO.prototype, "total", void 0);
__decorate([
    Expose(),
    Type(() => VenueCostDTO),
    __metadata("design:type", Array)
], CostsByVenueDTO.prototype, "venues", void 0);
export class GetCostsForEmployeeDTO {
    constructor(vals) {
        safeAssign(this, vals);
    }
}
__decorate([
    Expose(),
    IsDateString(),
    __metadata("design:type", String)
], GetCostsForEmployeeDTO.prototype, "from", void 0);
__decorate([
    Expose(),
    IsDateString(),
    __metadata("design:type", String)
], GetCostsForEmployeeDTO.prototype, "to", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], GetCostsForEmployeeDTO.prototype, "employeeId", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], GetCostsForEmployeeDTO.prototype, "includeAncillaryCosts", void 0);
export class CostsForEmployeeDTO {
    constructor(vals) {
        safeAssign(this, vals);
    }
}
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], CostsForEmployeeDTO.prototype, "total", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], CostsForEmployeeDTO.prototype, "employeeId", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], CostsForEmployeeDTO.prototype, "employeeName", void 0);
__decorate([
    Expose(),
    Type(() => CostByEmploymentTypeDTO),
    __metadata("design:type", CostByEmploymentTypeDTO)
], CostsForEmployeeDTO.prototype, "employmentType", void 0);
__decorate([
    Expose(),
    Type(() => CostByStatusDTO),
    __metadata("design:type", CostByStatusDTO)
], CostsForEmployeeDTO.prototype, "status", void 0);
__decorate([
    Expose(),
    Type(() => CostByComponentsDTO),
    __metadata("design:type", CostByComponentsDTO)
], CostsForEmployeeDTO.prototype, "components", void 0);
//# sourceMappingURL=cost-structure.dto.js.map